import EventBus from '@/utile/eventBus'

const state = {
  isWaiting: false,
  m_id: '',
  m_name: '',
  m_jobGrade: '',
  m_hp: '',
  m_profile_img: '',
  renewTime: 0,
  timer: null,
  test: 0
}

const getters = {
}

const mutations = {
  setManager (state, data) {
    if (data.isWaiting) {
      state.isWaiting = data.isWaiting
      state.m_id = data.m_id
      state.m_name = data.m_name
      state.m_jobGrade = data.m_jobGrade
      state.m_hp = data.m_hp
      state.m_profile_img = data.m_profile_img
      // localStorage.setItem('manager_id', state.m_id)
    }
  }
}

const actions = {
  update ({ commit, state }) {
    this.requestData(`/rep.manager.api`, {'param': { 'type': 'managerUpdate', 'm_id': state.m_id }}, {}).then(result => {
      // console.log('member:', result.array)
      const data = result.array
      commit('setManager', data)
    }).catch((err) => {
      console.log(err)
      state.renewTime = 0
    })
  },
  initManagerCheckTimer ({ dispatch, commit, state }) { // 매니저 상태 체크
    state.renewTime = new Date().getTime() + ((1000 * 60) * 30) // 30분에 한번 정보 업데이트 초기 업데이트
    dispatch('update')
    setInterval(() => {
      const date = new Date()
      if (state.renewTime === 0 || state.renewTime <= date.getTime()) {
        state.renewTime = date.getTime() + ((1000 * 60) * 30) // 30분에 한번 정보 업데이트
        dispatch('update')
      }
    }, 1000 * 15) // 15초에 한번 체크
  },
  inquiry ({ commit, state }, { type, form }) { // 매니저 상태 체크
    if (state.isWaiting) {
      this.requestData(`/rep.manager.api`, {'param': { 'type': type, 'm_id': state.m_id, 'form': form }}, {}).then(result => {
        // console.log('member:', result.array)
        const msg = result.array.msg
        if (msg) {
          EventBus.$emit('alert', msg)
        }
      }).catch((err) => {
        console.log(err)
      })
    } else {
      EventBus.$emit('alert', '현재 대기중인 담당자가 없습니다. 고객센터로 연락주시면 빠르고 친철하게 상담하여 드리겠습니다.')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/manager.js